import { Button } from "@progress/kendo-react-buttons";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { FieldWrapper } from "@progress/kendo-react-form";
import { TextArea } from "@progress/kendo-react-inputs";
import { useState } from "react";


export type NewUserPerformanceNote = {
  Note: string;
};

type Props = {
  loading: boolean;
  cancel: () => void;
  save: (formData: FormData) => void;
};

const UserNoteEditUI: React.FC<Props> = ({ loading, cancel, save }) => {
  const [note, setNote] = useState<NewUserPerformanceNote>({ Note: '' });
  const [files, setFiles] = useState<File[]>([]);

  return (
    <Dialog title="Add Note" className="dialog-w800" onClose={cancel}>
      <form className="k-form k-form-md p-0">
        <FieldWrapper>
          <TextArea
            autoFocus
            placeholder="Note"
            value={note.Note}
            onChange={(e) => setNote({ ...note, Note: e.target.value })}
          />
        </FieldWrapper>
        <FieldWrapper>
          <input type="file" multiple onChange={(e) => setFiles(Array.from(e.target.files || []))} />
          {files.length > 0 && <ul className="mt-2 list-unstyled">{files.map(f => <li key={f.name}>{f.name}</li>)}</ul>}
        </FieldWrapper>
      </form>
      <DialogActionsBar>
        <Button disabled={loading} onClick={cancel}>
          Cancel
        </Button>
        <Button disabled={loading || !note.Note} themeColor="success" onClick={() => {
            const fd = new FormData();
            fd.append('Note', note.Note);
            files.forEach(f => fd.append('Attachments', f));
            save(fd);
        }}>
          Create
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default UserNoteEditUI;
